import Image from "next/legacy/image";

import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  project: { siteName },
} = getPublicConfig();

export const EmptyModelList = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-col items-center space-y-4 pt-4 font-normal text-gray-700 sm:py-0">
      <Image
        alt={siteName}
        src="/images/user/model.png"
        layout="fixed"
        width={170}
        height={170}
        unoptimized
      />
      <div className="text-lg">沒有{title}</div>
    </div>
  );
};
